import(/* webpackMode: "eager", webpackExports: ["StyledJsxRegistry"] */ "/vercel/path0/frontend/app/registery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Scripts"] */ "/vercel/path0/frontend/app/Scripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsContextProvider","useAnalytics"] */ "/vercel/path0/packages/shared-ui/client/analytics/AnalyticsContextProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticationClientWrapper"] */ "/vercel/path0/packages/shared-ui/client/auth/AuthenticationClientWrapper.tsx");
